import { AllowedDeliveryChannel } from ".";
import { WidgetSettingsGetDto } from "clearline-api";

export class FeatureModel implements WidgetSettingsGetDto {
  deliveryMethod: AllowedDeliveryChannel;
  description? = "";
  notificationKey = "";
  configured = false;
  videoId? = "";
  isAvailableForConditions = true;
  isAvailableForKiosk = false;
  useForUnified = false;
  useOnCfs = false;
  isCustomApp = false;

  get code() {
    return this.id.toString();
  }

  constructor(
    public id: number, // WidgetType
    public name: string,
    public icon: string,
    public disabled = false
  ) {}
}

export interface FeatureData {
  userCardCode?: string;
}
